<template>
  <div class="error-container text-danger">
    <h1>{{ $t("Erreur Serveur Backend") }}</h1>
    <p>{{ $t("Le serveur backend est inaccessible ou a rencontré une erreur.") }}</p>
    <p>{{ $t("Veuillez réessayer plus tard ou contacter l'administrateur.") }}</p>
    <Button @click="errorStore.error = !errorStore.error" severity="secondary" raised icon="fa-solid fa-repeat" :label="$t('Réessayer')"></Button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import useErrorStore from 'src/stores/errorStore';
import { mapStores } from 'pinia';

export default defineComponent({

  computed: {
    ...mapStores(useErrorStore),
  }
})
</script>

<style scoped>
.error-container {
  max-width: 500px;
  margin: 100px auto;
  padding: 32px;
  background: var(--color-red-50);
  border: 1px solid var(--color-red-300);
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}
h1 {
  margin-bottom: 16px;
  font-size: 2rem;
}
p {
  margin-bottom: 8px;
}
</style>
